import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

export const appsystemAPI = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    // 📋 LIST – for table
    getAppIssueReports: build.query<
      { data: any[]; count: number },
      {
        page?: number;
        rowsPerPage?: number;
        issueType?: string;
        status?: string;
      }
    >({
      queryFn: async ({
        page = 1,
        rowsPerPage = 100,
        issueType = "ALL",
        status = "ALL",
      }) => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage - 1;

        let query = supabase
          .from("app_issue_reports")
          .select(
            "id, email, created_at, name, issue_type, title, status, description, screenshot_url",
            { count: "exact" },
          )
          .order("created_at", { ascending: false })
          .range(start, end);

        if (issueType !== "ALL") {
          query = query.eq("issue_type", issueType);
        }

        if (status !== "ALL") {
          query = query.eq("status", status);
        }

        const { data, error, count } = await query;

        if (error) return { error };

        return {
          data: {
            data: data || [],
            count: count || 0,
          },
        };
      },
      providesTags: ["app-system"],
    }),

    // 🔍 DETAILS – when row is clicked
    getAppIssueReportDetails: build.query<any, number>({
      queryFn: async (id: number) => {
        const { data, error } = await supabase
          .from("app_issue_reports")
          .select("*")
          .eq("id", id)
          .single();

        if (error) return { error };
        return { data };
      },
      providesTags: (_r, _e, id) => [{ type: "app-system", id }],
    }),

    // 🔄 UPDATE STATUS – Pending → Resolved / Ignored
    updateAppIssueStatus: build.mutation<
      any,
      { id: number; status: "PENDING" | "RESOLVED" | "IGNORED" }
    >({
      queryFn: async ({ id, status }) => {
        const { data, error } = await supabase
          .from("app_issue_reports")
          .update({ status })
          .eq("id", id)
          .select()
          .single();

        if (error) return { error };
        return { data };
      },
      invalidatesTags: (_r, _e, { id }) => [
        "app-system",
        { type: "app-system", id },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAppIssueReportsQuery,
  useLazyGetAppIssueReportsQuery,
  useGetAppIssueReportDetailsQuery,
  useUpdateAppIssueStatusMutation,
} = appsystemAPI;
